export default {
  loggedIn: {
    deposit: 'ฝากเงิน',
    withdraw: 'ถอนเงิน',
    balance: 'ยอดคงเหลือทั้งหมด',
    cash: 'เงินสด',
    bonus: 'โบนัส',
    withdrawable: 'ถอนได้',
    transaction: 'ธุรกรรม',
    history: 'ประวัติ',
    myBet: 'My Bet',
    rollover: 'ยอดหมุนเวียน',
    vault: 'ตู้นิรภัย',
    notification: 'การแจ้งเตือน',
    affiliate: 'พันธมิตร - รับ $5,000 ต่อเดือน',
    affiliateTitle: 'พันธมิตร',
    affiliateBadge: 'รับ $5,000 ต่อเดือน',
    settings: 'การตั้งค่า',
    currency: 'สกุลเงิน',
    language: 'ภาษา',
    liveSupport: 'ฝ่ายสนับสนุนสด',
    signOut: 'ออกจากระบบ'
  }
};
